import uuid from 'uuid'
import * as BlipSdk from 'blip-sdk'
import * as WebSocketTransport from 'lime-transport-websocket'

import { TenantService } from '../../utils/TenantService'

import { DOMAIN, HOSTNAME, HOSTNAME_TENANT_DEFAULT, PORT } from '../../settings'

const id = uuid.v4()

const tenant = TenantService.getTenantFromHost(window.location.host)

const clientInstance = ({ id, password }, { port, hostName, domain }) => {
  const organizationHostName = tenant
    ? `${tenant}.${hostName || HOSTNAME_TENANT_DEFAULT}`
    : hostName || HOSTNAME

  return new BlipSdk.ClientBuilder()
    .withIdentifier(id)
    .withPassword(password)
    .withRoutingRule('promiscuous')
    .withTransportFactory(() => new WebSocketTransport(undefined, false))
    .withEcho(true)
    .withDomain(domain || DOMAIN)
    .withHostName(organizationHostName)
    .withPort(port || PORT)
    .build()
}

const instance = clientInstance(
  { id, password: undefined },
  { port: undefined, hostName: undefined, domain: undefined },
)

const state = {
  instance,
  botIdentity: undefined,
  userIdentity: id,
  hasMessages: false,
  password: undefined,
}

const getAuthHeader = (user, key) => {
  const userAndKey = `${user}@${DOMAIN}:${atob(key)}`

  return `Basic ${btoa(userAndKey)}`
}

const getters = {
  instance: (state) => state.instance,
  botIdentity: (state) => state.botIdentity,
  userIdentity: (state) =>
    state.instance._clientChannel.localNode.split('@')[0],
  hasMessages: (state) => state.hasMessages,
  authHeader: (state) => getAuthHeader(state.client, state.password),
}

const mutations = {
  setClient(state, { userIdentity, userPassword, port, hostName, domain }) {
    state.client = userIdentity
    state.password = userPassword
    state.port = port
    state.hostName = hostName
    state.domain = domain

    state.instance = clientInstance(
      { id: state.client, password: state.password },
      { port: state.port, hostName: state.hostName, domain: state.domain },
    )
  },
  setBotIdentity(state, identity) {
    state.botIdentity = identity
  },
  setHasMessages(state, hasMessages) {
    state.hasMessages = hasMessages
  },
}

export default {
  state,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/store/modules/client.ts